// -- other --
import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../core/img";
import Slider from "react-slick";
import {Toaster} from 'react-hot-toast';
import "slick-carousel/slick/slick.css";
import FeatherIcon from "feather-icons-react";
import "slick-carousel/slick/slick-theme.css";
import {all_routes} from "../router/all_routes";
import Select from "react-select";
import series from 'async/series';
import  './style.css';
// -- biz9 --
import SubValue from "../subValue";
import {UrlQuery} from "biz9-react-utility";
import {Log,Num,Str,DateTime,Obj,Status_Type,Response_Logic} from "biz9-utility";
import {Config,Field,Message,Title,Type,Url} from "../../constant";
import {App,Field_Logic,Image,Style,Toast_Message,Storage,User} from "../../project";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";
import {Review_Table,Review_Field,Review_Stat} from "biz9-review";
import {Data_Logic} from "biz9-data-app";
import {Image_Format} from "biz9-image";
import {Favorite_Url,Favorite_Table,Favorite_Service,Favorite_Logic} from "biz9-favorite";
import {User_Logic,User_Table} from "biz9-user";
const Home = () => {
    /* -- DEFINE -- *
     * --- BUTTONZ ---
     * btn_post_favorite - post-user-favorites.
     * --- FIELDZ ---
     * - categorys
     *   - cover_image
     *   - roll_over_image
     * - 3 - ITEMS
     *   - value
     * - 14 - ITEMS
     *   - icon
     *   - title
     *   - description
     *   - button_title
     *   - link
     * - 43 - ITEMS - Partners
     *   thumb - image
     * - 41 - ITEMS -
     *   - thumb - image
     *   - title - string
     *   - sub_note - string
     * ---- BACKGROUND-IMAGEZ ----
     * - 11 - image-file - /source/public/assets/img/home/app_select_man.jpg
     * - 36 - image-file - /source/public/assets/img/bg/section-bg-02.jpg
     */
    const query = UrlQuery();
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    // -- search --
    const [val_search_keyword,setValSearchKeyWord] = useState("");
    const [val_search_type, setValSearchType] = useState("any");
    // -- user --
    const [user,setUser] = useState(User.get());
    // -- product --
    const [products_popular,setProductsPopular] = useState([]);
    const [products_latest,setProductsLatest] = useState([]);
    const [products_top,setProductsTop] = useState([]);
    const [products_trending,setProductsTrending] = useState([]);
    // -- categorys --
    const [categorys,setCategorys] = useState([]);
    const [category_product_1_label, setCategoryProduct1Label] = useState("");
    const [category_product_2_label, setCategoryProduct2Label] = useState("");
    const [category_product_3_label, setCategoryProduct3Label] = useState("");
    const [category_product_4_label, setCategoryProduct4Label] = useState("");
    const [category_product_5_label, setCategoryProduct5Label] = useState("");
    const [category_product_6_label, setCategoryProduct6Label] = useState("");
    // -- product categorys --
    const [product_1_categorys, setProduct1Categorys] = useState([]);
    const [product_2_categorys, setProduct2Categorys] = useState([]);
    const [product_3_categorys, setProduct3Categorys] = useState([]);
    const [product_4_categorys, setProduct4Categorys] = useState([]);
    const [product_5_categorys, setProduct5Categorys] = useState([]);
    const [product_6_categorys, setProduct6Categorys] = useState([]);
    // -- partners --
    const [partners, setPartners]= useState([]);
    const [content_partners, setContentPartners]= useState([]);
    // -- blog-posts --
    const [blog_posts, setBlogPosts] = useState([]);
    // -- products-explore --
    const [products_explore_1,setExplore1Products] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:5,blank:true,data:{image_filename:''}}));
    const [products_explore_2,setExplore2Products] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:1,blank:true,data:{image_filename:''}}));
    const [products_explore_3,setExplore3Products] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:1,blank:true,data:{image_filename:''}}));
    const [products_explore_4,setExplore4Products] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:1,blank:true,data:{image_filename:''}}));
    // -- reviews --
    const [reviews,setReviews]= useState(Data_Logic.get(Review_Table.REVIEW,0,{get_user:true,test:true,count:10}));
    // -- faqs --
    const [faqs, setFaqs]= useState(Data_Logic.get_faqs(Data_Logic.get(Portal_Table.FAQ,0,{blank:true,test:true,count:10})));
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_page_data();
            }, []);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_items_data();
            }, []);
    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10,user_id:User.get().id};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.HOME.title_url,option);
        bind_page(data);
    };
   async function get_items_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10,user_id:User.get().id};
        const [response,data] = await Portal_Remote_Page.get_home_items(App.get_url(Portal_Page.HOME[Portal_Type.ITEMS_URL]),option);
        bind_items(data);
        Toast_Message.dismiss();
    }
const get_view_review_count_label = (item) =>{
    // -- star_count 400 Views ( 25 reviews )
    let view_count = !Str.check_is_null(item[Portal_Stat.POST_VIEW]) ? item[Portal_Stat.POST_VIEW] :  "0";
    let review_count = !Str.check_is_null(item[Review_Field.REVIEW_COUNT]) ? item[Review_Field.REVIEW_COUNT] :  "0";
    return  view_count + " views ( "+ review_count + " reviews ) ";
}
async function bind_page(data) {
    // -- page --
    setPage(data[Portal_Type.PAGE]);
    // -- page-edit --
    setEditMode(query.get('edit_mode'));
    setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
    // -- sub-values --
    bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
};
async function bind_items(data) {
    // -- bind-products --
    setProductsPopular(data[Type.PRODUCTS_POPULAR]);
    setProductsLatest(data[Type.PRODUCTS_LATEST]);
    setProductsTop(data[Type.PRODUCTS_TOP]);
    setProductsTrending(data[Type.PRODUCTS_TRENDING]);
    // -- categorys --
    setCategorys(data[Portal_Type.CATEGORYS]);
    // -- category-products --
    setCategoryProduct1Label(data[Type.CATEGORY_1_PRODUCTS_TITLE]);
    setProduct1Categorys(data[Type.CATEGORY_1_PRODUCTS]);
    setCategoryProduct2Label(data[Type.CATEGORY_2_PRODUCTS_TITLE]);
    setProduct2Categorys(data[Type.CATEGORY_2_PRODUCTS]);
    setCategoryProduct3Label(data[Type.CATEGORY_3_PRODUCTS_TITLE]);
    setProduct3Categorys(data[Type.CATEGORY_3_PRODUCTS]);
    setCategoryProduct4Label(data[Type.CATEGORY_4_PRODUCTS_TITLE]);
    setProduct4Categorys(data[Type.CATEGORY_4_PRODUCTS]);
    setCategoryProduct5Label(data[Type.CATEGORY_5_PRODUCTS_TITLE]);
    setProduct5Categorys(data[Type.CATEGORY_5_PRODUCTS]);
    setCategoryProduct6Label(data[Type.CATEGORY_6_PRODUCTS_TITLE]);
    setProduct6Categorys(data[Type.CATEGORY_6_PRODUCTS]);
    //blog_posts
    setBlogPosts(data[Portal_Type.BLOG_POSTS]);
    //explore
    if(data[Type.PRODUCTS_EXPLORE_1].length>0){
        setExplore1Products(data[Type.PRODUCTS_EXPLORE_1]);
    }
    if(data[Type.PRODUCTS_EXPLORE_2].length>0){
        setExplore2Products(data[Type.PRODUCTS_EXPLORE_2]);
    }
    if(data[Type.PRODUCTS_EXPLORE_3].length>0){
        setExplore3Products(data[Type.PRODUCTS_EXPLORE_3]);
    }
    if(data[Type.PRODUCTS_EXPLORE_4].length>0){
        setExplore4Products(data[Type.PRODUCTS_EXPLORE_4]);
    }
    // -- faq --
    setFaqs(data[Portal_Type.FAQS]);
    // -- partners --
    setPartners(data[Type.PARTNERS]);
};
async function bind_sub_values(data_sub_group) {
    // -- bind-sub-values --
    for(const sub_group in data_sub_group){
        if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
            sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
        }else{
            sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
        }
    }
    Storage.post_sub_value_group(sub_value_edit,data_sub_group);
};
async function update_sub_value(sub_value) {
    // -- page-edit-sub-values --
    if(sub_value.type != Sub_Value_Type.ITEMS){
        setSubValueGroup(sub_value_group => ({
                    ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                    }
                    }));
    }else{
        setSubValueGroup(sub_value_group => ({
                    ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                    }
                    }));
    }
}
const app_types = [{ value: "0", label: "Select" },{ value: "Mobile", label: "Mobile Application" },{ value: "Website", label: "Website Application" },{ value: "Landing Page", label: "Landing Page" }
];
const [stateVariable, setStateVariable] = useState('');
const [parentState, setParentState] = useState('');

const updateSearchKeywordVal = (event) => {
    setValSearchKeyWord(event.target.value);
};
const updateSearchType = (event) => {
    setValSearchType(event.value);
};
async function btn_post_favorite(titles,is_favorite,id) {
    let parent = Data_Logic.get(Portal_Table.PRODUCT,id);
    let favorite = Favorite_Logic.get(parent,user);
    if(!user.is_guest){
        switch(titles){
            case 'products_popular':
                setProductsPopular(products_popular.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'products_latest':
                setProductsLatest(products_latest.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'products_top':
                setProductsTop(products_top.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'products_trending':
                setProductsTrending(products_trending.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_1_categorys':
                setProduct1Categorys(product_1_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_2_categorys':
                setProduct2Categorys(product_2_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_3_categorys':
                setProduct3Categorys(product_3_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_4_categorys':
                setProduct4Categorys(product_4_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_5_categorys':
                setProduct5Categorys(product_5_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
            case 'product_6_categorys':
                setProduct6Categorys(product_6_categorys.map(item =>
                            item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
                            ));
                break;
        }
        if(!is_favorite){
            let [response,data] = await Favorite_Service.post(App.get_url(Favorite_Url.POST),favorite);
            if(response.status == Status_Type.SUCCESS){
                Storage.post_favorites([...Storage.get_favorites(), data]);
            }
        }else{
            let [response,data] = await Favorite_Service.delete(App.get_url(Favorite_Url.DELETE),favorite);
            let remove_list = Obj.filter_remove(Portal_Field.PARENT_ID,id,Storage.get_favorites());
            Storage.post_favorites(Obj.filter_remove(Portal_Field.PARENT_ID,id,Storage.get_favorites()));
        }

    }else{
        Toast_Message.error(Message.LOGIN);
    }
};
const imgSlider = {
dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false, // set to true if you want to use custom arrows
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 768,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const imgslideroption = {
dots: false,
      nav: false,
      infinite: true,
      speed: 500,
      swipe: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const slideslideroption = {
dots: true,
      nav: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      draggable: true,
      tochMove: true,
      swipe: true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const clientslideroption = {
dots: true,
      nav: false,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 3,
            },
      },
      ],
};
const testimonialslideroption = {
dots: false,
      loop: true,
      nav: true,
      infinite: true,
      smartSpeed: 500,
      slidesToShow: 3,
      slidesToScroll: 6,
      responsive: [
      {
breakpoint: 1200,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 600,
            settings: {
slidesToShow: 1,
            },
      },

      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
return (
        <div style={{ overflowX: "hidden" }}>
        <>
        <Toaster />
        {/* SECTION-1-TOP-START */}
        <section className="hero-section">

        <div className="banner-bg-imgs">
        <ImageWithBasePath
        src="/assets/img/bg/banner-bg-01.png"
        className="banner-bg-one"
        alt="img"
        />
        <ImageWithBasePath
        src="/assets/img/bg/banner-bg-02.png"
        className="banner-bg-two"
        alt="img"
        />
        <ImageWithBasePath
        src="/assets/img/bg/banner-bg-04.png"
        className="banner-bg-four"
alt="img"
/>
</div>
<div className="container">
<div className="row">
<div className="col-lg-8">
<div className="banner-content" data-aos="fade-up">
<div className="banner-head">
<h1 className="mb-2">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
{sub_value_group.sub_value_1.value}
</h1>
<p className="d-inline-flex">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,2):""}
{sub_value_group.sub_value_2.value}
</p>
</div>
<div className="banner-form">
<form>
<div className="banner-search-list home1select">
<div className="input-block">
<label>Application Type</label>
<Select classNamePrefix="react-select" options={app_types} className="form-control select" styles={Style.customStyles} onChange={updateSearchType} defaultValue={app_types[0]}/>
</div>
<div className="input-block border-0">
<label>Keywords</label>
<input
defaultValue={sub_value_group.sub_value_4.value}
onChange={updateSearchKeywordVal}
type="text"
className="form-control"
placeholder={sub_value_group.sub_value_4.value}
/>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,4):""}
</div>
</div>
<div className="input-block-btn">
<Link to={all_routes.product_app+"?keyword="+val_search_keyword+"&type="+val_search_type}>
<button
className="btn btn-lg btn-primary d-inline-flex align-items-center justify-content-center"
type="submit">      <i className="ti ti-search" />
{"Search"}

</button>
</Link>

</div>
</form>
</div>
<div className="popular-search">
<h5>Popular Searches: </h5>
<ul>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,3):""}
{sub_value_group.sub_value_3.items.map((item) => (
            <li>
            <Link to={all_routes.product_app+"?keyword="+item.value+"&type=any"}>{item.value}</Link>
            </li>
            ))}
</ul>
</div>
</div>
</div>
<div className="col-lg-4">
<div className="banner-img">
<div className="banner-img-right">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,30):""}
<ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_30.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />
</div>
<ImageWithBasePath
src="/assets/img/bg/banner-small-bg-02.png"
className="banner-small-bg-two"
alt="img"
/>
</div>
</div>
</div>
</div>
</section>
{/* SECTION-1-TOP-END */}

{/* SECTION-2-PRODUCT-START */}
<section className="explore-gigs-section">

<div className="container">
<div className="section-head d-flex">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,5):""}
{sub_value_group.sub_value_5.value}{"  "}
</span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,6):""}
{sub_value_group.sub_value_6.value}
</h2>
</div>
<div className="section-tab">
<ul
className="nav nav-pills inner-tab aos"
id="pills-tab"
role="tablist"
data-aos="fade-up"
>
<li className="nav-item" role="presentation">
<button
className="nav-link active"
id="pills-popular-tab"
data-bs-toggle="pill"
data-bs-target="#pills-popular"
type="button"
role="tab"
aria-controls="pills-popular"
aria-selected="false"
>
Popular
</button>
</li>
<li className="nav-item" role="presentation">
<button
className="nav-link"
id="pills-latest-tab"
data-bs-toggle="pill"
data-bs-target="#pills-latest"
type="button"
role="tab"
aria-controls="pills-latest"
aria-selected="true"
>
Latest
</button>
</li>
<li className="nav-item" role="presentation">
<button
className="nav-link"
id="pills-rating-tab"
data-bs-toggle="pill"
data-bs-target="#pills-rating"
type="button"
role="tab"
aria-controls="pills-rating"
aria-selected="false"
>
Top Ratings
</button>
</li>
<li className="nav-item" role="presentation">
<button
className="nav-link"
id="pills-trend-tab"
data-bs-toggle="pill"
data-bs-target="#pills-trend"
type="button"
role="tab"
aria-controls="pills-trend"
aria-selected="false"
>
Trending{" "}
</button>
</li>
</ul>
</div>
</div>
<div className="tab-content dashboard-tab">
<div className="tab-pane fade show active" id="pills-popular" role="tabpanel"aria-labelledby="pills-popular-tab">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider owl-carousel">
<Slider {...imgslideroption}>
{/* grid1 start */}
{products_popular.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link  to={Url.APP_DETAIL+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="AppZ" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('products_popular',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={all_routes.product_app+"?category="+item.category} className="badge bg-light" >
                {item.category}
            </Link>
                <p className="d-inline-flex align-items-center">
                <i className="ti ti-coin-filled me-1" />
                {item.type}
            </p>
                </div>
                <div className="gigs-title">
                <h5>
                <Link to={Url.APP_DETAIL+item.title_url}>
                {item.title}
            </Link>
                </h5>
                </div>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {get_view_review_count_label(item)}
            </span>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h6>{Str.get_money(item.cost)}</h6>
                </div>
                </div>
                </div>
                ))}
{/* grid1 end */}
</Slider>
</div>
</div>
</div>
</div>

<div className="tab-pane fade" id="pills-latest" role="tabpanel" aria-labelledby="pills-latest-tab" >
<div className="row">
<div className="col-md-12">
<div className="gigs-card-slider owl-carousel">
<Slider {...imgslideroption}>
{/* grid2 start */}
{products_latest.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={Url.APP_DETAIL+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="AppZ" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('products_latest',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={all_routes.product_app+"?category="+item.category} className="badge bg-light" >
                {item.category}
            </Link>
                <p className="d-inline-flex align-items-center">
                <i className="ti ti-coin-filled me-1" />
                {item.type}
            </p>
                </div>
                <div className="gigs-title">
                <h5>
                <Link to={Url.APP_DETAIL+item.title_url}>
                {item.title}
            </Link>
                </h5>
                </div>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {get_view_review_count_label(item)}
            </span>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h6>{Str.get_money(item.cost)}</h6>
                </div>
                </div>
                </div>
                ))}
{/* grid2 stop */}
</Slider>
</div>
</div>
</div>
</div>
<div className="tab-pane fade" id="pills-rating" role="tabpanel" aria-labelledby="pills-rating-tab">
<div className="row">
<div className="col-md-12">
<div className="gigs-card-slider owl-carousel">
<Slider {...imgslideroption}>
{/* grid3 start */}
{products_top.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link  to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="AppZ" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('products_top',item.is_favorite,item.id)}>
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={all_routes.product_app+"?category="+item.category} className="badge bg-light" >
                {item.category}
            </Link>
                <p className="d-inline-flex align-items-center">
                <i className="ti ti-coin-filled me-1" />
                {item.type}
            </p>

                </div>
                <div className="gigs-title">
                <h5>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h5>
                </div>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {get_view_review_count_label(item)}
            </span>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h6>{Str.get_money(item.cost)}</h6>
                </div>
                </div>
                </div>
                ))}
{/* grid3 end */}
</Slider>
</div>
</div>
</div>
</div>
<div className="tab-pane fade" id="pills-trend" role="tabpanel" aria-labelledby="pills-trend-tab">
<div className="row">
<div className="col-md-12">
<div className="gigs-card-slider owl-carousel">
<Slider {...imgslideroption}>
{/* grid4 start */}
{products_trending.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link  to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="AppZ" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('products_trending',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={all_routes.product_app+"?category="+item.category} className="badge bg-light" >
                {item.category}
            </Link>
                <p className="d-inline-flex align-items-center">
                <i className="ti ti-coin-filled me-1" />
                {item.type}
            </p>

                </div>
                <div className="gigs-title">
                <h5>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h5>
                </div>
                <div className="star-rate">
                <span>
                <i className="fa-solid fa-star" />
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {get_view_review_count_label(item)}
            </span>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h6>{Str.get_money(item.cost)}</h6>
                </div>
                </div>
                </div>
                ))}
{/* grid4 end */}
</Slider>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
{/* SECTION-2-PRODUCT-END */}
{/* SECTION-3-CATEGORY-START */}
<section className="popular-section">
<div className="popular-img">
<div className="popular-img-left">
<ImageWithBasePath src="/assets/img/bg/banner-bg-04.png" alt="Shape" />
</div>
<div className="popular-img-right">
<ImageWithBasePath src="/assets/img/bg/shape-08.png" alt="Shape" />
</div>
</div>
<div className="container">
<div className="section-header aos" data-aos="fade-up">
<h2 className="text-white">
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,7):""}
{sub_value_group.sub_value_7.value}
</span>{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,8):""}
{sub_value_group.sub_value_8.value}
</h2>
</div>
<div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 align-items-center">
{/* Category Grid */}
{categorys.map((item) => (
            <div className="col d-flex aos" data-aos="fade-up">
            <div className="category-grid flex-fill">
            <div className="popular-icon">
            <span>
            <ImageWithBasePath  src={Image.get_url(item.cover_image,Image_Format.ORIGINAL)}
            alt="Icon" />
            </span>
            </div>
            <div className="popular-content">
            <h5>{item.title}</h5>
            <p>{item.product_count} {" AppZ"}</p>
            </div>
            <div className="category-overlay">
            <Link to={all_routes.product_app+"?category="+item.title}>
            <div className="category-overlay-img">
            <ImageWithBasePath
            src={Image.get_url(item.roll_over_image,Image_Format.ORIGINAL)}
            className="img-fluid"
            alt={item.title}
            />
                <div className="category-overlay-content">
                <h5>{item.title}</h5>
                <i className="feather-arrow-up-right" />
                </div>
                </div>
                </Link>
                </div>
                </div>
                </div>
                ))}

                </div>
                </div>
                </section>
{/* SECTION-3-CATEGORY-END */}
{/* SECTION-4-CATEGORY-DETAIL-START-HERE */}
<section className="listing-section">
<div className="container">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,9):""}
{sub_value_group.sub_value_9.value}
</span>
{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,10):""}
{sub_value_group.sub_value_10.value}
</h2>
</div>
{/* Listing Tabs */}
<div className="listing-tab">
<div className="listing-slider">
<ul className="nav nav-tabs">
<li className="nav-item">
<Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#category_product_1" >
{category_product_1_label}
</Link>
</li>
<li className="nav-item">
<Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#category_product_2">
{category_product_2_label}
</Link>
</li>
<li>
<Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#category_product_3">
{category_product_3_label}
</Link>
</li>

<li>
<Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#category_product_4">
{category_product_4_label}
</Link>
</li>
<li>
<Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#category_product_5">
{category_product_5_label}
</Link>
</li>
<li>
<Link to="#" className="nav-link" data-bs-toggle="tab"data-bs-target="#category_product_6">
{category_product_6_label}
</Link>
</li>
</ul>
</div>
</div>
{/* /Listing Tabs */}
<div className="tab-content">
{/* Tab_1-START */}
<div className="tab-pane fade show active" id="category_product_1" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_1_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_1_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_1-END */}
{/* Tab_2-START */}
<div className="tab-pane fade" id="category_product_2" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_2_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_2_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_2-END */}
{/* Tab_3-START */}
<div className="tab-pane fade" id="category_product_3" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_3_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_3_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_3-END */}
{/* Tab_4-START */}
<div className="tab-pane fade" id="category_product_4" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_4_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"#"}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection" >
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_4_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_4-END */}
{/* Tab_5-START */}
<div className="tab-pane fade" id="category_product_5" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_5_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_5_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_5-END */}
{/* Tab_6-START */}
<div className="tab-pane fade" id="category_product_6" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{product_6_categorys.map((item) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"#"}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)}  className="img-fluid" alt="AppZ"/>
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {Str.check_is_true(item.featured) && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {Str.check_is_true(item.hot)&&(
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link hidden={false} key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite('product_6_categorys',item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"/app/"+item.title_url} className="badge bg-primary-light">
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}
            {Num.get_decimal(item.rating_avg)} ({item[Review_Stat.POST_REVIEW] ? item[Review_Stat.POST_REVIEW]: "0"} Reviews)
            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <div className="gigs-share">
                <span className="badge">{App.get_app_delivery_time(item.cost)}</span>
                </div>
                <h5>{Str.get_money(item.cost)}</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* Tab_6-END */}
{/* Tab_6-START */}
</div>
</div>
</section>
{/* SECTION-4-CATEGORY-DETAIL-END */}
{/* SECTION-5-CONTENT-START */}
<section className="provide-section" >
<div className="container">
<div className="row">
<div className="col-lg-6 col-md-9">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,11):""}
{sub_value_group.sub_value_11.value}
</span>{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,12):""}
{sub_value_group.sub_value_12.value}
</h2>
<p>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,13):""}
{sub_value_group.sub_value_13.value}
</p>
</div>
</div>
</div>

{/* 14 START */}
<div className="row justify-content-center">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,14):""}
{sub_value_group.sub_value_14.items.map((item) => (
            <div className="col-lg-4 col-md-6">
            <div className="provide-box">
            <div className="provide-icon">
            <ImageWithBasePath src={Image.get_url(item.icon,Image_Format.ORIGINAL)} alt="icon"/>
            </div>
            <h3>
            {item.title}
            </h3>
            <p>
            {item.description}
            </p>
            <Link to={item.link} className="btn btn-primary">
            {item.button_title}
            <i className="fa-solid fa-caret-right" />
            </Link>
            </div>
            </div>
            ))}
</div>
{/* 14 END */}

</div>
</section>
{/* SECTION-5-CONTENT-END */}
{/* /Find Your Needs */}
{/* Clinets */}
<div className="client-slider-sec">
<div className="container">
<div className="row">
<div className="col-lg-12">
<div className="section-header aos" data-aos="fade-up">
<h3  className="text-white" style={{color:'white', textAlign: 'center' }}>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,40):""}
{sub_value_group.sub_value_40.value}
</h3>
</div>
<div className="clients-slider">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,43):""}
<Slider {...clientslideroption}>
{sub_value_group.sub_value_43.items.map((item) => (
            <div className="client-logo">
            <ImageWithBasePath src={Image.get_url(item.thumb,Image_Format.ORIGINAL)} className="w-auto" alt="img" />
            </div>
            ))}
</Slider>
</div>
</div>
</div>
</div>
</div>
{/* /Clinets */}
{/* Popular Lists */}
<section className="top-listing-section">
<div className="container">
<div className="row">
<div className="col-md-12">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,18):""}
{sub_value_group.sub_value_18.value}
</span>{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,39):""}
{sub_value_group.sub_value_39.value}
</h2>
</div>
<div className="tab-content country-lists">

{/* BLOG-START */}
<div className="tab-pane fade show active" id="uae" role="tabpanel">
<div className="row aos" data-aos="fade-up" data-aos-delay={500}>
<div className="col-md-12">
<div className="gigs-card-slider listing-gigs">
<Slider {...imgslideroption}>
{blog_posts.map((blog_post) => (
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider ">
            <div className="slide-images">
            <Link to={"/blog/"+blog_post.title_url}>
            <ImageWithBasePath src={Image.get_url(blog_post.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="AppZ" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            <Link to={"/blog/"+blog_post.title_url}>
            <span className="badge bg-info">
            <i className="fa-solid fa-circle" />
            {blog_post.category}
            </span>
            </Link>
            </div>
            </div>
            <div className="gigs-content">
            <div className="gigs-info">
            <p className="gigs-location">
            <ImageWithBasePath
            src="/assets/img/icons/map-pin-check.svg"
            alt="Icon"
            />
            {DateTime.get_pretty(blog_post.date_create)}
</p>

    </div>
    <div className="gigs-title">
    <h3>
    <Link to={"#"}>
    {blog_post.title}
</Link>
    </h3>
    <p className="loc-user-name">{blog_post.author}</p>
    </div>


    </div>
    </div>
    ))}

    </Slider>
    </div>
    </div>
    </div>
    </div>
{/* BLOG-END */}
</div>

{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,17):""}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,44):""}
<div className="cta-section">
<div className="cta-wrap">
<div className="row gx-0 align-items-center">
<div className="col-md-8">
<div className="cta-info">
<span className="badge">
{sub_value_group.sub_value_17.value}
</span>
<h3>
{sub_value_group.sub_value_44.value}
</h3>
</div>
</div>
<div className="col-md-4 text-md-end">
<div className="cta-btn">
<Link to={'#'} className="btn btn-primary">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,45):""}
{sub_value_group.sub_value_45.value}
<i className="fa-solid fa-caret-right" />
</Link>
</div>
</div>
</div>
<div className="cta-bg">
<div className="cta-bg1">
<ImageWithBasePath
src="/assets/img/bg/contact-bg-01.png"
alt="Shape"
/>
</div>
<div className="cta-bg2">
<ImageWithBasePath
src="/assets/img/bg/contact-bg-02.png"
alt="Shape"
/>
</div>
</div>
</div>
</div>

<div className="popular-services">
<div className="row">
<div className="col-md-12">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,20):""}
{sub_value_group.sub_value_20.value}
</span>
{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,21):""}
{sub_value_group.sub_value_21.value}
</h2>
</div>
</div>
{/* Products_Explore_1_Start */}
<div className="col-xl-3 col-lg-4 col-sm-6">
<div className="category-item">
<div className="category-img">
<Link to={all_routes.product_app+"?category="+products_explore_1[0].category}>
<ImageWithBasePath src={Image.get_url(products_explore_1[0].image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="category img" />
</Link>
<div className="category-slug">
<Link to={all_routes.product_app+"?category="+products_explore_1[0].category}>{products_explore_1[0].category}</Link>
</div>
</div>

<div className="category-list">
<ul>
{products_explore_1.map((item) => (
            <li>
            <Link to={"app/"+item.title_url}>
            {item.title}
            <i className="feather icon-arrow-up-right" />
            </Link>
            </li>
            ))}
</ul>
</div>

</div>
</div>
{/* Products_Explore_1_End */}

{/* Products_Explore_2_Start */}
<div className="col-xl-3 col-lg-4 col-sm-6">
<div className="category-item">
<div className="category-img">
<Link to={all_routes.product_app+"?category="+products_explore_2[0].category}>
<ImageWithBasePath src={Image.get_url(products_explore_2[0].image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="category img" />
</Link>
<div className="category-slug">
<Link to={all_routes.product_app+"?category="+products_explore_2[0].category}>{products_explore_2[0].category}</Link>
</div>
</div>
<div className="category-list">
<ul>
{products_explore_2.map((item) => (
            <li>
            <Link to={"app/"+item.title_url}>
            {item.title}
            <i className="feather icon-arrow-up-right" />
            </Link>
            </li>
            ))}
</ul>
</div>
</div>
</div>
{/* Products_Explore_2_End */}

{/* Products_Explore_3_Start */}
<div className="col-xl-3 col-lg-4 col-sm-6">
<div className="category-item">
<div className="category-img">
<Link to={all_routes.product_app+"?category="+products_explore_3[0].category}>
<ImageWithBasePath src={Image.get_url(products_explore_3[0].image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="category img" />
</Link>
<div className="category-slug">
<Link to={all_routes.product_app+"?category="+products_explore_3[0].category}>{products_explore_3[0].category}</Link>
</div>
</div>
<div className="category-list">
<ul>
{products_explore_3.map((item) => (
            <li>
            <Link to={"app/"+item.title_url}>
            {item.title}
            <i className="feather icon-arrow-up-right" />
            </Link>
            </li>
            ))}
</ul>
</div>
</div>
</div>
{/* Products_Explore_3_End */}

{/* Products_Explore_4_Start */}
<div className="col-xl-3 col-lg-4 col-sm-6">
<div className="category-item">
<div className="category-img">
<Link to={all_routes.product_app+"?category="+products_explore_4[0].category}>
<ImageWithBasePath src={Image.get_url(products_explore_4[0].image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="category img" />
</Link>
<div className="category-slug">
<Link to={all_routes.product_app+"?category="+products_explore_4[0].category}>{products_explore_4[0].category}</Link>
</div>
</div>
<div className="category-list">
<ul>
{products_explore_4.map((item) => (
            <li>
            <Link to={"app/"+item.title_url}>
            {item.title}
            <i className="feather icon-arrow-up-right" />
            </Link>
            </li>
            ))}
</ul>
</div>
</div>
</div>
{/* Products_Explore_4_End */}

</div>
</div>
</div>
</div>
</div>
<div className="con-bg">
<ImageWithBasePath src="/assets/img/bg/contact-bg.png" alt="icon" />
</div>
</section>
{/* /Popular Lists */}
{/* Testimonials */}

{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,22):""}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,23):""}
<section className="testimonial-section">
<div className="container">
<div className="row">
<div className="col-lg-12">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>
{sub_value_group.sub_value_22.value}
</span>
{" "}
{sub_value_group.sub_value_23.value}
</h2>
</div>
<div className="testimonial-slider">
<Slider {...testimonialslideroption}>

{reviews.map((item) => (
            <div className="testimonial-item aos" data-aos="fade-up">
            <div className="testimonial-icon">
            <ImageWithBasePath src="/assets/img/icons/arrow-icon.svg" alt="icon" />
            </div>
            <h4>{item.title}</h4>
            <p>
            “{item.comment}”
            </p>
            <div className="star-rate">
            <span>
            {Array.from({ length: parseInt(item[Review_Field.RATING]) }).map((_, index) => (
                        <i className="fa-solid fa-star filled" />
                        ))}
            <i className="fa-solid fa-star filled" />
            </span>
            </div>
            <div className="testimonial-user">
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} alt="img" />
            <div className="testimonial-info">
            <h6>{item.user.username}</h6>
            <p>{'location'}</p>
            </div>
            </div>
            </div>
            ))}
            </Slider>
            </div>
            </div>
            </div>
            </div>
            <div className="testimonial-bg">
            <div className="testimonial-bg1">
            <ImageWithBasePath
            src="/assets/img/bg/testimonial-bg-01.png"
            alt="Shape"
            />
            </div>
            <div className="testimonial-bg2">
            <ImageWithBasePath
            src="/assets/img/bg/testimonial-bg-02.png"
            alt="Shape"
            />
            </div>
            <div className="testimonial-bg3">
            <ImageWithBasePath
            src="/assets/img/bg/testimonial-bg-03.png"
            alt="Shape"
            />
            </div>
            </div>
            </section>
{/* /Testimonials */}
{/* Expert Section */}
<section className="popular-section expert-section">
<div className="popular-img">
<div className="popular-img-left">
<ImageWithBasePath
src="/assets/img/bg/banner-bg-04.png"
alt="Shape"
/>
</div>
<div className="popular-img-right">
<ImageWithBasePath src="/assets/img/bg/shape-08.png" alt="Shape" />
</div>
</div>
<div className="container">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,46):""}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,47):""}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,49):""}
<div className="row align-items-center">
<div className="col-lg-6">
<div className="expert-header">
<div className="section-header aos" data-aos="fade-up">
<h2>
<span>{sub_value_group.sub_value_46.value}
</span>
{" "}
{sub_value_group.sub_value_47.value}
</h2>
</div>
</div>
</div>
<div className="col-lg-6">
<div className="section-header" data-aos="fade-up">
<h6 className="fw-medium text-white">{sub_value_group.sub_value_49.value}
</h6>
</div>
</div>
</div>

<div className="expert-wrapper">

<div className="row gx-0 justify-content-center">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,41):""}
{sub_value_group.sub_value_41.items.map((item) => (
            <div className="col-lg-4 col-md-6 aos" data-aos="fade-up">
            <div className="expert-item">
            <div className="expert-icon">
            <img src={Image.get_url(item.thumb,Image_Format.ORIGINAL)} alt="img"/>
            </div>
            <div className="expert-info">
            <h5>{item.title}</h5>
            <p>{item.sub_note}</p>
            </div>
            </div>
            </div>
            ))}


</div>
</div>
</div>
</section>
{/* /Expert Section */}
{/* FAQ */}
<section className="explore-services-sec">
<div className="section-bg">
<ImageWithBasePath
src="/assets/img/bg/section-bg-06.png"
className="explore-bg1"
alt="img"
/>
</div>
<div className="container">
<div className="faq-sec">
<div className="row align-items-center">
<div className="col-lg-4">
<div className="faq-heading aos" data-aos="fade-up">
<div className="section-header">
<h2>
<span>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,32):""}
{sub_value_group.sub_value_32.value}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,34):""}
</span>
{" "}
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,33):""}
{sub_value_group.sub_value_33.value}
</h2>
</div>
<p>
{sub_value_group.sub_value_34.value}
</p>
<Link to={"#"} className="btn btn-primary">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,35):""}
{sub_value_group.sub_value_35.value}
<i className="fa-solid fa-caret-right" />
</Link>
</div>
</div>
<div className="col-lg-8">
<div className="faq-wrapper faq-lists">
{faqs.map((item) => (
            <div className="faq-card aos" data-aos="fade-up">
            <h4 className="faq-title">
            <Link className="collapsed" data-bs-toggle="collapse" to={"#"+item.id}  aria-expanded="false">
            {item.question}
            </Link>
            </h4>
            <div id={item.id} className="card-collapse collapse">
            <div className="faq-content">
            <p>
            {item.answer}
            </p>
            </div>
            </div>
            </div>
            ))}
</div>
</div>
</div>
</div>
<div className="trusted-customers-sec">
<div className="section-bg">
<ImageWithBasePath
src="/assets/img/bg/banner-bg-04.png"
className="explore-bg2"
alt="img"
/>
</div>
<div className="trusted-customers">
<div className="section-bg">
<ImageWithBasePath
src="/assets/img/bg/section-bg-03.png"
className="trusted-bg-one"
alt="img"
/>
<ImageWithBasePath
src="/assets/img/bg/section-bg-03.png"
className="trusted-bg-two"
alt="img"
/>
</div>
<div
className="section-header"
data-aos="fade-up"
data-aos-delay={500}>
<h2>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,36):""}
{sub_value_group.sub_value_36.value}
</h2>
<p>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,37):""}
{sub_value_group.sub_value_37.value}
</p>
</div>
<div className="more-btn text-center" data-aos="fade-up" data-aos-delay={500} >
<Link to={'#'} className="btn btn-primary">
<ImageWithBasePath
src="assets/img/icons/list-search-icon.svg"
className="me-2"
alt="img"
/>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,38):""}
{sub_value_group.sub_value_38.value}
</Link>
</div>
</div>
</div>
</div>
</section>
{/* /FAQ */}
</>
<SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
</div>
);
};

export default Home;
